<template>
  <b-card no-body class="image-uploader linked-card">
    <maintain-aspect-ratio class="card-header card-img btn-card">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <i class="fa fa-cloud-upload fa-2x mb-1" />
        <div class="w-75">{{ label }}</div>
      </div>
    </maintain-aspect-ratio>
    <b-progress v-if="progress.max" :value="progress.value" :max="progress.max" animated />
    <input
      type="file"
      @change="handleUpload($event)"
      accept="image/*"
      class="card-link"
    />
  </b-card>
</template>

<script>
import MaintainAspectRatio from '@/components/utility/MaintainAspectRatio';
import { mapGetters } from 'vuex';

export default {
  name: 'image-uploader',
  props: {
    label: {
      type: String,
      default: 'Upload Your Own Image',
    },
    useAI: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      progress: {
        value: 0,
        max: 0,
      },
    };
  },
  computed: {
    ...mapGetters([
      'hubDefaultWidth',
      'hubDefaultHeight',
    ]),
  },
  methods: {
    fetchWithProgress(url, opts = {}, onProgress) {
      // mimic `fetch` interface, but support progress
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = e => resolve(e.target.responseText);
        xhr.onerror = reject;
        if (xhr.upload && onProgress) {
          xhr.upload.onprogress = onProgress;
        }
        xhr.open(opts.method || 'get', url);
        xhr.send(opts.body);
      });
    },
    async handleUpload(event) {
      const file = event.target.files[0];
      if (!file) return; // user cancelled, ignore silently

      const formData = new FormData();
      formData.append('image', file);
      formData.append('client', window.Renoworks.client);
      if (this.useAI) {
        formData.append('ai', true);
      }
      if (this.hubDefaultWidth && this.hubDefaultHeight) {
        const physicalWidth = this.hubDefaultWidth / 12;
        const physicalHeight = this.hubDefaultHeight / 12;
        formData.append('defaultWidth', physicalWidth);
        formData.append('defaultHeight', physicalHeight);
      }

      // submit the upload
      this.progress.max = 100; // show progress bar
      const uuid = await this.fetchWithProgress(`${window.Renoworks.Util.getBaseApiUrl()}/Upload`, {
        method: 'POST',
        body: formData,
      }, (progress) => {
        this.progress.value = progress.loaded;
        this.progress.max = progress.total;
      });
      this.progress.max = 0; // hide progress bar

      // check that it succeeded
      if (/ERROR/.test(uuid)) {
        throw new Error(uuid);
      }

      // succeed
      this.$emit('upload', { uuid, useAI: this.useAI });
    },
  },
  components: {
    MaintainAspectRatio,
  },
};
</script>

<style lang="scss">
.image-uploader {
  .maintain-aspect-ratio {
    padding: 0 8px;
  }
  .progress {
    position: absolute;
    left: 0.5rem;
    right: 0.5rem;
    bottom: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImageUploader.vue